export default __webpack_public_path__ + "static/fintracase3-ace71d84f9af46a6e6936b322b20feaf.png";